export default function FinalCTA() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="relative rounded-2xl overflow-hidden aspect-[2/1] mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20shopping%20lifestyle%20scene%20with%20laptop%20and%20fashion%20items%20scattered%20artfully%20on%20warm%20cream%20desk%2C%20soft%20natural%20daylight%2C%20editorial%20photography%2C%20terracotta%20and%20neutral%20accents%2C%20cozy%20atmosphere%2C%20high%20detail%2C%20warm%20ambient%20glow&width=1200&height=600&seq=cta-new-final-2026&orientation=landscape"
              alt="Explore the latest Sugargoo Spreadsheet now"
              title="Sugargoo Spreadsheet - Start Shopping Smarter Today"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/25 via-transparent to-transparent"></div>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-2">
            Explore the Latest
          </h2>
          <p className="font-heading text-3xl md:text-5xl font-bold italic text-foreground-400 mb-2">
            Sugargoo Spreadsheet
          </p>
          <p className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-8">
            Shop Smarter
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto whitespace-nowrap bg-foreground-950 text-background-50 font-bold px-10 py-4 rounded-full text-sm hover:bg-foreground-800 transition-colors cursor-pointer flex items-center justify-center gap-2"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-external-link-line text-sm"></i></span>
              Visit Main Website
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto whitespace-nowrap bg-primary-500 text-background-50 font-bold px-10 py-4 rounded-full text-sm hover:bg-primary-600 transition-colors cursor-pointer flex items-center justify-center gap-2"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-shopping-bag-line text-sm"></i></span>
              Browse All Products
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}